module.exports = ".section {\n  padding: 1.5rem !important; }\n\n.bid-button {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/product/product.component.scss
// module id = ./src/app/componentes/product/product.component.scss
// module chunks = main